module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel_02_bg-ae25b69c60b5ede5bc5254697ea454d5.png";